import { render, staticRenderFns } from "./inqure.vue?vue&type=template&id=186b90c1&scoped=true"
import script from "./inqure.vue?vue&type=script&lang=js"
export * from "./inqure.vue?vue&type=script&lang=js"
import style0 from "./inqure.vue?vue&type=style&index=0&id=186b90c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186b90c1",
  null
  
)

export default component.exports